module.exports = __webpack_public_path__ + "media/images/landkit/portfolio/portfolio-10-0484f770a0fbe5029e305d51c3599d16.jpg";